import { store } from '../../../store/configure';

export const processFlow = (history, nuevoPaso) => {
    var state = store.getState();
    if (state.navigation.flujo === "OnBoarding" && !(state.navigation.paso === nuevoPaso)) {
        switch (state.navigation.paso) {
            case 0:
                return history.push('/reconocimiento-facial/id?id=' + state.token.id);
            case 8:
                return history.push('/paso-' + state.navigation.paso);
            case 9:
                return history.push('/tyc');
            case 10:
                return history.push('/cargando-venta');
            case 11:
                return history.push('/felicitaciones');
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/OnBoarding/services/flowService.js